import { useEffect, useState } from 'react';
import api from 'utils/api';
import { formatNumber } from 'utils/formatNumber';

const transformWalletOptions = (raw) => ({
  icon: raw?.amount.icon,
  label: `${formatNumber(raw?.amount, 0)} Gems`,
  sub_label: raw?.bonus
    ? `+ Additional ${formatNumber(raw?.bonus, 0)} Gems`
    : null,
  price_label: `for ${formatNumber(raw?.price)} PHP`,
  price: raw?.price,
});

const useWalletOptions = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [list, setList] = useState([]);
  useEffect(() => {
    setIsLoading(true);
    api
      .get('/wallet/v1/conversion', {
        session: true,
      })
      .then((res) => {
        setIsLoading(false);
        if (res?.error) {
          setError(res?.data || { message: 'Unable to load options.' });
          return;
        }
        const games = (res.data || []).map(transformWalletOptions);
        setList(games);
      });
  }, [setList, setIsLoading]);
  return [isLoading, list, error];
};

export default useWalletOptions;
